export default {
    "Feature Service": "esri/layers/FeatureLayer",
    "Vector Tile Service": "esri/layers/VectorTileLayer",
    "Map Service": "esri/layers/MapImageLayer",
    "Image Service": "esri/layers/ImageryLayer",
    "Scene Service": "esri/layers/SceneLayer"
};
